// eslint-disable-next-line
import {injectable} from "inversify";
import {
    IRma,
    IRmaAddNoteRequest,
    IValidateItemsActionRequest,
    IRmaApproveRequest,
    IRmaData,
    IReceiveShipmentRequest,
    IRmaReopenReuest,
    IRmaRejectRequest,
    IRmaCancelRequest,
    IRestockRequest, IRmaRejectItemRequest,
} from "../../pages/manage-returns/rma-page/rma-types";
import {rootContainer, TYPE} from "../container/root";
import {IApiResponse, IHttpService} from "../http-service";


@injectable()
class RmaListService {
	private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async rejectItem(id: number, data: IRmaRejectItemRequest): Promise<IRmaData> {
        const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/reject-item`, data);
        return res.payload;
    }

	public async fetchRma(id: number): Promise<IRmaData> {
		const res = await this.httpService.get<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}`);
		return res.payload;
	}
    
	public async approve(id: number, data: IRmaApproveRequest): Promise<IRmaData > {
		const res = await this.httpService.put<IApiResponse<IRmaData >>(`/rms-api/manage-returns/rma/${id}/approve`, data);
		return res.payload;
	}

	public async receiveShipment(id: number, data: IReceiveShipmentRequest): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/receive-shipment`, data);
		return res.payload;
	}

	public async reopen(id: number, data: IRmaReopenReuest): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/reopen`, data);
        return res.payload;
	}
    
	public async reject(id: number, data: IRmaRejectRequest): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/reject`, data);
		return res.payload;
	}
	
    public async cancel(id: number, data: IRmaCancelRequest): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/cancel`, data);
        return res.payload;
	}
    
	public async markAsDone(id: number): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/mark-as-done`);
		return res.payload;
	}
 
	public async resendStatusEmail(id: number, emailLogId: number): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/resend-status-email/${emailLogId}`);
		return res.payload;
	}

    public async releaseExchange(id: number): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/release-exchange`);
		return res.payload;
	}

	public async restock(id: number, data: IRestockRequest): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/restock`, data);
		return res.payload;
	}

	public async addNote(id: number, data: IRmaAddNoteRequest): Promise<Pick<IRma, 'timeline'>> {
		const res = await this.httpService.put<IApiResponse<Pick<IRma, 'timeline'>>>(`/rms-api/manage-returns/rma/${id}/add-note`, data);
		return res.payload;
	}
    
    
    public async saveValidation(id:number, data: IValidateItemsActionRequest) {
        const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/save-validation`, data);
        return res.payload;
    }

    public async saveValidationAll(id:number) {
        const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/save-validation-all`);
        return res.payload;
    }

    public async resolveErrors(id: number): Promise<IRmaData> {
		const res = await this.httpService.put<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${id}/resolve-errors`);
		return res.payload;
	}
}


export default RmaListService;
